import React from "react";

const variants = {
  filled: "bg-ink text-surface-alt border-transparent hover:bg-ink-soft",
  ghost: "bg-canvas text-ink border-transparent hover:bg-hairline",
  outline: "bg-transparent text-ink border-hairline hover:bg-paper",
};

const Button = ({
  as: Component = "a",
  variant = "filled",
  className = "",
  children,
  arrow = false,
  ...props
}) => {
  return (
    <Component
      className={`group inline-flex min-h-11 items-center justify-center gap-1 rounded-pill border px-4 text-body font-semibold no-underline transition-transform duration-150 hover:-translate-y-0.5 active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${variants[variant]} ${className}`}
      {...props}
    >
      <span>{children}</span>
      {arrow ? (
        <span
          aria-hidden="true"
          className="inline-block transition-transform duration-150 group-hover:translate-x-1 rtl:group-hover:-translate-x-1"
        >
          →
        </span>
      ) : null}
    </Component>
  );
};

export default Button;
